import {
  SET_DATAHUB_FRAMEWORKS,
  SET_DATAHUB_TAB,
  SET_EXCEL_FILE_DATA,
  SET_EXCEL_FILES,
  SET_FRAMEWORK_DISCLOSURES,
  SET_KPI_TAGS,
  SET_ORGANIZATIONAL_TAGS,
  SET_DATAHUB_DATASET,
  SET_DATAHUB_KPI_GROUP_FILTER,
  SET_COLUMN_VISIBILITY,
  UPDATE_COLUMN_VISIBILITY,
  RESET_COLUMN_VISIBILITY,
  SET_COLUMN_ORDER,
  UPDATE_COLUMN_ORDER,
  SET_FRAMEWORK_DRAWER_DATA,
  SET_FRAMEWORK_DRAWER_OPEN,
} from "constants/datahub/datasetConst";
import apiBolerplate from "utils/_helpers/apiBolerplate";
import { reduxGet } from "utils/_helpers/reduxGet";

// ----------------- Payloads -----------------

// export function setEsgComplianceAssessmentDetails(payload) {
//   return {
//     type: SET_ESG_COMPLIANCE_ASSESSMENT_DETAILS,
//     payload: payload,
//   };
// }

export function setDataHubTab(payload) {
  reduxGet.dispatch({
    type: SET_DATAHUB_TAB,
    payload: payload,
  });
}

export function setDataHubKpiGroupFilter(payload) {
  reduxGet.dispatch({
    type: SET_DATAHUB_KPI_GROUP_FILTER,
    payload: payload,
  });
}

export const setDatahubDataset = (payload) => {
  reduxGet.dispatch({
    type: SET_DATAHUB_DATASET,
    payload,
  });
};

export const setColumnVisibility = (context, columns) => ({
  type: SET_COLUMN_VISIBILITY,
  payload: { context, columns },
});

export const updateColumnVisibility = (context, columnId, isHidden) => ({
  type: UPDATE_COLUMN_VISIBILITY,
  payload: { context, columnId, isHidden },
});

export const resetColumnVisibility = (context) => ({
  type: RESET_COLUMN_VISIBILITY,
  payload: { context },
});

export const setColumnOrder = (context, columnOrder) => ({
  type: SET_COLUMN_ORDER,
  payload: { context, columnOrder },
});

export const updateColumnOrder = (context, newOrder) => ({
  type: UPDATE_COLUMN_ORDER,
  payload: { context, newOrder },
});

export const setDatahubColumns = (columns) => ({
  type: "SET_DATAHUB_COLUMNS",
  payload: columns,
});

export const updateDatahubColumn = (id, updates) => ({
  type: "UPDATE_DATAHUB_COLUMN",
  payload: { id, updates },
});

// ----------------- Actions -----------------

export async function getKpiSurveyList({
  entity_id,
  limit,
  starting_after,
  survey_type = "KPI_SURVEY",
  keyword,
}) {
  const data = await apiBolerplate({
    url: "/kpi_surveys/get_kpi_surveys",
    bodyData: { keyword, entity_id, limit, starting_after, survey_type },
    hideLoader: true,
    hideMsg: true,
  });

  return data; // Return the data for further use
}

export async function updateKpiSurvey({
  kpi_survey_id,
  type_of_data_collection,
  data,
  type_of_individual_value,
}) {
  const response = await apiBolerplate({
    url: "/kpi_surveys/update_survey_data",
    bodyData: {
      kpi_survey_id,
      type_of_data_collection,
      data,
      type_of_individual_value,
    },
    messageType: "success",
    hideLoader: true,
    hideMsg: false,
  });

  return response; // Return the data for further use
}

export async function deleteKpiSurvey({ survey_id, deletion_reason }) {
  const response = await apiBolerplate({
    url: "/kpi_surveys/delete_survey",
    bodyData: {
      survey_id,
      deletion_reason,
    },
    hideLoader: true,
    hideMsg: false,
    messageType: "error",
  });

  return response; // Return the data for further use
}

export async function getStakeholdersDatahub(param) {
  const data = await apiBolerplate({
    url: "/stakeholder/get_structured_stakeholders_for_datahub",
    bodyData: {
      ...param,
    },
    hideLoader: true,
    hideMsg: true,
  });

  return data; // Return the data for further use
}

export async function assignDataHubKpiSurvey(assignDetails) {
  const data = await apiBolerplate({
    url: `/assign_stakeholder/${assignDetails?.url}`,
    bodyData: { ...assignDetails },

    hideLoader: true,
    hideMsg: false,
    messageType: "success",
    // callback: () => {
    //   assignDetails?.url === "assign_contributors_in_datahub_kpi_survey" &&
    //     generateDataHubKpiExcel(assignDetails?.survey_id);
    // },
  });

  return data; // Return the data for further use
}

export async function generateDataHubKpiExcel(survey_id) {
  const data = await apiBolerplate({
    url: `/datahub_excel/generate_excel`,
    bodyData: { survey_id },
    hideLoader: true,
    hideMsg: false,
    messageType: "success",
  });

  return data; // Return the data for further use
}

export const setOrganizationalTags = (payload) => {
  return {
    type: SET_ORGANIZATIONAL_TAGS,
    payload,
  };
};

export function getOrganizationalTags(parent_id, keyword) {
  return async (dispatch) => {
    apiBolerplate({
      dispatch,
      url: `/datahub_excel/get_entity_units`,
      bodyData: { parent_id, keyword },
      hideLoader: true,
      hideMsg: true,
      callback: (data) => {
        // final actions
        dispatch(setOrganizationalTags(data?.result));
      },
    });
  };
}

export const setKpiTags = (payload) => {
  return {
    type: SET_KPI_TAGS,
    payload,
  };
};

export function getKpiTags(keyword, limit) {
  return async (dispatch) => {
    apiBolerplate({
      dispatch,
      url: `/datahub_excel/get_kpi_tags`,
      bodyData: { keyword, limit },
      hideLoader: true,
      hideMsg: true,
      callback: (data) => {
        // final actions
        dispatch(setKpiTags(data?.result));
      },
    });
  };
}

export const setExcelFiles = (payload) => {
  return {
    type: SET_EXCEL_FILES,
    payload,
  };
};

export function getExcelFiles(parent_id) {
  return async (dispatch) => {
    apiBolerplate({
      dispatch,
      url: `/datahub_excel/get_excel_files`,
      bodyData: { parent_id },
      hideLoader: true,
      hideMsg: true,
      callback: (data) => {
        // final actions
        dispatch(setExcelFiles(data?.result));
      },
    });
  };
}

export const setExcelFileData = (payload) => {
  return {
    type: SET_EXCEL_FILE_DATA,
    payload,
  };
};

export function getExcelFileData(excel_id) {
  return async (dispatch) => {
    apiBolerplate({
      dispatch,
      url: `/datahub_excel/get_excel_data`,
      bodyData: { excel_id },
      hideLoader: true,
      hideMsg: true,
      callback: (data) => {
        // final actions
        dispatch(setExcelFileData(data?.result));
      },
    });
  };
}

export function uploadExcelFile({ data, file }) {
  return async (dispatch) => {
    apiBolerplate({
      dispatch,
      url: `/datahub_excel/upload_excel`,
      bodyData: { ...data },
      hideLoader: false,
      messageType: "success",
      files: file,
      // callback: (data) => {
      //   // final actions
      //   dispatch(setExcelFiles(data?.result));
      // },
    });
  };
}

export async function getBaseKPIOptions({ kpiId }) {
  const data = await apiBolerplate({
    url: `/base_kpi_surveys/get-base-master-kpi-types`,
    bodyData: {
      base_master_kpi_id: kpiId,
      starting_after: 0,
      limit: 500,
    },
    hideLoader: true,
    hideMsg: true,
  });

  return data?.result;
}

export async function getMasterKpiList({
  keyword,
  limit,
  starting_after,
  survey_type = "KPI_SURVEY",
}) {
  const data = await apiBolerplate({
    url: "/kpi_surveys/get_master_kpis",
    bodyData: { keyword, limit, starting_after, survey_type },
    hideLoader: true,
    hideMsg: true,
  });

  return data; // Return the data for further use
}

export async function addSurveyKpi(addSurveyParams) {
  const response = await apiBolerplate({
    url: "/kpi_surveys/add_survey",
    bodyData: {
      ...addSurveyParams,
    },
    hideLoader: true,
    // hideMsg: true,
    messageType: "success",
  });

  return response; // Return the data for further use
}

export async function getMasterKpiData({
  starting_after = 0,
  limit = 10,
  keyword,
}) {
  const data = await apiBolerplate({
    url: "kpi-master/get_kpi_master_data",
    bodyData: { starting_after, limit, keyword },
    hideLoader: true,
    hideMsg: true,
    method: "post",
  });

  return data;
}
// Filetr Meta Data
export async function getMasterKpiMetaData() {
  const data = await apiBolerplate({
    url: "kpi-master/get_kpi_master_metadata",
    hideLoader: true,
    hideMsg: true,
    method: "post",
  });

  return data;
}

// Filtered Data

export async function getMasterKpiFilteredData({
  starting_after = 0,
  limit = 10,
  keyword,
  filters = {},
}) {
  const data = await apiBolerplate({
    url: "kpi-master/get_kpi_master_filtered",
    bodyData: { starting_after, limit, search: keyword, filters },
    hideLoader: true,
    hideMsg: true,
    method: "post",
  });

  return data;
}

export async function getMasterKpiDataGrouping(details) {
  const data = await apiBolerplate({
    url: "kpi-master/get_kpi_master_data_grouping",
    bodyData: { ...details },
    hideLoader: true,
    hideMsg: true,
    method: "post",
  });

  return data; // Return the data for further use
}

export async function getBaseKpiTypes({ kpiId }) {
  const data = await apiBolerplate({
    url: "kpi-master/get_base_kpi_types",
    bodyData: { kpiId },
    hideLoader: true,
    hideMsg: true,
  });

  return data; // Return the data for further use
}

export async function updateBaseKpiTypes({
  activeTypesIds = [],
  base_master_kpi_id = "",
  evidenceIds = [],
}) {
  
  const data = await apiBolerplate({
    url: "kpi-master/update_base_kpi_types",
    bodyData: base_master_kpi_id
      ? { activeTypesIds, base_master_kpi_id, evidenceIds }
      : { evidenceIds },
    hideLoader: true,
    hideMsg: true,
  });

  return data; // Return the data for further use
}

// getDataLinkageKpis.js

export async function getDataLinkageKpis({
  limit,
  page,
  searchQuery = "",
  ...details
}) {
  const data = await apiBolerplate({
    url: "data-linkage/get-kpis",
    bodyData: { limit, page, keyword: searchQuery, ...details },
    hideLoader: true,
    hideMsg: true,
  });

  return data;
}
export async function getFilteredDataLinkageKpis({
  limit,
  page,
  filters = {},
  searchQuery,
}) {
  const data = await apiBolerplate({
    url: "data-linkage/filter-kpis",
    bodyData: { limit, page, filters, search: searchQuery },
    hideLoader: true,
    hideMsg: true,
  });

  return data;
}

export async function getDataLinkageAddedFrameworks() {
  const data = await apiBolerplate({
    url: "datahub_linkages/linkages/get_added_frameworks",
    bodyData: {},
    hideLoader: true,
    hideMsg: true,
    method: "post",
  });

  return data; // Return the data for further use
}

export const setFrameworkDisclosures = (payload) => {
  return {
    type: SET_FRAMEWORK_DISCLOSURES,
    payload,
  };
};

export const setFrameworkDrawerData = (payload) => {
  return {
    type: SET_FRAMEWORK_DRAWER_DATA,
    payload,
  };
};

export const setFrameworkDrawerOpen = (payload) => {
  return {
    type: SET_FRAMEWORK_DRAWER_OPEN,
    payload,
  };
};

export function getFrameworkDisclosures({
  framework_id,
  organization_id,
  starting_after,
  limit,
  kpi_id,
  keyword,
  status,
}) {
  return async (dispatch) => {
    apiBolerplate({
      dispatch,
      url: "datahub_linkages/linkages/get_disclosures",
      bodyData: {
        framework_id,
        organization_id,
        starting_after,
        limit,
        kpi_id,
        keyword,
        status,
      },
      hideLoader: true,
      hideMsg: true,
      callback: (data) => {
        // final actions

        dispatch(setFrameworkDisclosures(data?.result));
      },
    });
  };
}

export const setDatahubFrameworks = (payload) => {
  return {
    type: SET_DATAHUB_FRAMEWORKS,
    payload,
  };
};

export function getFilteredFrameWorkList(country_code, organization_id) {
  return async (dispatch) => {
    apiBolerplate({
      dispatch,
      url: "/framework/frameworks/get_published_frameworks",
      bodyData: { country_code, organization_id },
      hideLoader: false,
      hideMsg: true,
      callback: (data) => {
        // final actions
        dispatch(setDatahubFrameworks(data?.result));
      },
    });
  };
}

// export function getDataSetsDataList({ interval, starting_after, limit }) {
//   return async (dispatch) => {
//      apiBolerplate({
//       dispatch,
//       url: `/datahub_datasets?interval=${interval}`,
//       // bodyData: { framework_name, starting_after, limit },
//       hideLoader: false,
//       hideMsg: true,
//       method:"get",
//       callback: (data) => {
//         // final actions
//         dispatch(setDatahubDataset(data?.result));
//       },
//     });
//   };
// }
export const getDataSetsDataList = ({
  interval,
  page,
  limit,
  keyword,
  category,
  subcategory,
}) => {
  return async (dispatch) => {
    try {
      const data = await apiBolerplate({
        dispatch,
        url: "/datahub_datasets",
        bodyData: { interval, page, limit, keyword, category, subcategory },
        hideLoader: true,
        hideMsg: true,
        // method: "get",
      });

      dispatch(setDatahubDataset(data));
    } catch (error) {
      console.error("Error fetching datasets:", error);
    }
  };
};

// kpi Group

export async function getKpiGroupSurveyList({
  keyword,
  limit,
  starting_after,
  entity_id,
}) {
  const data = await apiBolerplate({
    url: "/kpi-master/get_kpi_group_data",
    bodyData: { keyword, limit, starting_after, entity_id },
    hideLoader: true,
    hideMsg: true,
  });

  return data; // Return the data for further use
}

export async function getFilterStructureData({
  search,
  limit = 500,
  starting_after,
  entity_id,
}) {
  const data = await apiBolerplate({
    url: "/kpi-master/get_kpi_filter_structure",
    bodyData: { limit, starting_after, entity_id, search },
    hideLoader: true,
    hideMsg: true,
  });

  return data; // Return the data for further use
}

// export async function  getFilterKpiGroupData({

//    entity_id,
//       kpi_count_range,
//          data_collection_for,
//         data_collection_by,
//          contributors,
//           approvers,
//          frequency,
//          limit=500

// }) {
//   const data = await apiBolerplate({
//     url: "/kpi-master/filter_kpi_group_data",
//     dispatch,
//     bodyData: { entity_id,
//       kpi_count_range,
//          data_collection_for,
//         data_collection_by,
//          contributors,
//           approvers,
//          frequency,
//          limit},
//     hideLoader: true,
//     hideMsg: true,
//   });

//    dispatch(setDataHubKpiGroupFilter(data)); // Return the data for further use
// }

export const getFilterKpiGroupData = ({
  entity_id,
  kpi_count_range,
  data_collection_for,
  data_collection_by,
  contributors,
  approvers,
  frequency,
  limit = 500,
  starting_after,
  keyword,
}) => {
  return async (dispatch) => {
    try {
      const data = await apiBolerplate({
        dispatch,
        url: "/kpi-master/filter_kpi_group_data",
        bodyData: {
          entity_id,
          kpi_count_range,
          data_collection_for,
          data_collection_by,
          contributors,
          approvers,
          frequency,
          limit,
          starting_after,
          search: keyword,
        },
        hideLoader: false,
        hideMsg: true,
        // method: "get",
      });

      dispatch(setDataHubKpiGroupFilter(data));
    } catch (error) {
      console.error("Error fetching datasets:", error);
    }
  };
};

export async function getViewEachKpiInKpiGroup({
  keyword,
  limit,
  starting_after,
  kpi_ids,
  dropdown_ids = [],
}) {
  const data = await apiBolerplate({
    url: "/kpi-master/view_each_kpi_in_kpi_group",
    bodyData: {
      keyword,
      limit,
      starting_after,
      kpi_ids,
      dropdown_ids: dropdown_ids || null,
    },
    hideLoader: true,
    hideMsg: true,
  });

  return data; // Return the data for further use
}

export async function createKpiGroupSurvey(details) {
  const response = await apiBolerplate({
    url: "/kpi-master/create_kpi_group",
    bodyData: {
      ...details,
    },
    hideLoader: true,
    hideMsg: false,
    messageType: "success",
  });

  return response; // Return the data for further use
}

export async function assignSstakeholdersDatahubKpiGroup({
  parent_entity_id,
  survey_id,
  contributors,
  approvers,
  receiving_date,
  frequency,
  ends,
  ends_on_date,
  frequency_range,
}) {
  const response = await apiBolerplate({
    url: "/kpi-master/assign_stakeholders_in_datahub_kpi_group",
    bodyData: {
      parent_entity_id,
      survey_id,
      contributors,
      approvers,
      receiving_date,
      frequency,
      ends,
      ends_on_date,
      frequency_range,
    },
    hideLoader: true,
    hideMsg: false,
    messageType: "success",
  });

  return response; // Return the data for further use
}

export function addFrameworksToDataLinkageTab({ framework_ids }) {
  return async (dispatch) => {
    apiBolerplate({
      dispatch,
      url: "datahub_linkages/linkages/add_frameworks",
      bodyData: { framework_ids },
      hideLoader: false,
      hideMsg: true,
      method: "post",
      callback: (data) => {
        // final actions
        // dispatch(setDatahubFrameworks(data?.result));
      },
    });
  };
}

export function linkUnlinkKpis({
  question_id,
  framework_id,
  organization_id,
  kpi_id,
  metric_ids,
  action,
  getFrameworkDisclosures,
  keyword,
  status,
}) {
  return async (dispatch) => {
    apiBolerplate({
      dispatch,
      url: "datahub_linkages/linkages/link_or_unlink",
      bodyData: {
        question_id,
        framework_id,
        organization_id,
        kpi_id,
        metric_ids,
        action,
      },
      hideLoader: false,
      hideMsg: true,
      callback: (data) => {
        // final actions
        if (!!getFrameworkDisclosures) {
          dispatch(
            getFrameworkDisclosures({
              framework_id,
              organization_id,
              starting_after: 0,
              limit: 10,
              kpi_id,
              keyword,
              status,
            })
          );
        }
      },
    });
  };
}
